var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2596 4.33334C11.2596 2.03126 8.88898 0.166672 5.96329 0.166672C3.03759 0.166672 0.666992 2.03126 0.666992 4.33334C0.666992 5.22657 1.02602 6.04948 1.63458 6.72917C1.29338 7.51563 0.73065 8.14063 0.723011 8.14844C0.666992 8.20834 0.651714 8.29688 0.684816 8.375C0.717918 8.45313 0.789214 8.5 0.870696 8.5C1.80264 8.5 2.57417 8.17969 3.12926 7.84896C3.94917 8.25782 4.91931 8.5 5.96329 8.5C8.88898 8.5 11.2596 6.63542 11.2596 4.33334ZM14.3661 10.0625C14.9746 9.38542 15.3337 8.5599 15.3337 7.66667C15.3337 5.92448 13.9714 4.4323 12.0413 3.8099C12.0642 3.98178 12.0744 4.15626 12.0744 4.33334C12.0744 7.09115 9.33204 9.33334 5.96329 9.33334C5.68829 9.33334 5.42093 9.3125 5.15611 9.28386C5.9582 10.7813 7.84246 11.8333 10.0374 11.8333C11.0813 11.8333 12.0515 11.5938 12.8714 11.1823C13.4265 11.513 14.198 11.8333 15.13 11.8333C15.2114 11.8333 15.2853 11.7839 15.3158 11.7083C15.3489 11.6328 15.3337 11.5443 15.2776 11.4818C15.27 11.474 14.7073 10.8516 14.3661 10.0625Z",
    fill: "#595959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreads);
export default __webpack_public_path__ + "static/media/threads.4de47a44.svg";
export { ForwardRef as ReactComponent };